module.exports = __webpack_public_path__ + "img/new14-2.80766c6f.jpg";